import { Component, createSignal, Show } from "solid-js"
import { Artwork } from "../../types";
import "../../assets/admin-tab.scss"
import { EntitiesTab } from "./entities";
import { EditLocationTab } from "./edit-location";
import { GoogleMapsGeocoderProvider } from "../../components/google-maps-geocoder-provider";

type Props = {
    artwork: Artwork;
}

export const AdminTab : Component<Props> = ({ artwork }) => {
    const [tab,setTab] = createSignal<string>("DepictedLocation");
    const activeClasses = (match: string) => match == tab() ? "vertical-tab-label active" : "vertical-tab-label";
    return (
        <div class="vertical-tabs-container">
            <div class="left-column">
                <div class={activeClasses("DepictedLocation")} onClick={() => setTab("DepictedLocation")}>
                    Depicted Location
                </div>
                <div class={activeClasses("Entities")} onClick={() => setTab("Entities")}>
                    Entities
                </div>
                <div class={activeClasses("Timeline")} onClick={() => setTab("Timeline")}>
                    Timeline
                </div>
            </div>
            <div class="right-column">
                <Show when={tab() == "Entities"}>
                    <div style="border: 1px solid #ccc;">
                        <EntitiesTab artwork={artwork} />
                    </div>
                </Show>
                <Show when={tab() == "DepictedLocation"}>
                    <div style="border: 1px solid #ccc;">
                        <GoogleMapsGeocoderProvider apiKey="AIzaSyAweLj0DgOj1Em6hgX0-yPuOmwlvXLCJ2c">
                            <EditLocationTab
                                artwork={artwork}
                                onComplete={() => setTab("Details")}
                                onCancel={() => setTab("Defails")}
                            />
                        </GoogleMapsGeocoderProvider>
                    </div>
                </Show>
                <Show when={tab() == "Timeline"}>
                    <div style="border: 1px solid #ccc;">
                        <h2>Timeline</h2>
                    </div>
                </Show>
            </div>
            
        </div>
    )
}